import { Mail } from "lucide-react";
import React, { useEffect, useState } from "react";
import Spin from "../../components/Spin";
import AuthLeftSide from "../../components/AuthLeftSide";
import { Formik } from "formik";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Link, useNavigate } from "react-router-dom";
import { ThemeToggle } from "../../components/ThemeToggle";
import { API, post } from "../../config";
import LogoSVG from "../../components/LogoSVG";
import FaviconSVG from "../../components/FaviconSVG";
import { ForgotPasswordSchema } from "../../lib/Validation";
import CustomLabelText from "../../components/CustomLabelText";

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const EmailVerification = localStorage.getItem("EmailVerification");
  const hasToken = localStorage.getItem("ts-auth-token");
  const clientId = localStorage.getItem("clientId");

  // *API Call for ForgotPassword - Start
  const handleFinish = async (value) => {
    try {
      setLoading(true);
      const { data } = await post(API.FORGOT_PASSWORD, value);
      if (data.status === 200) {
        setLoading(false);
        handleBackToLogin();
      } else {
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    userId && EmailVerification === "1" && hasToken && navigate("/trusts");
  }, [userId, EmailVerification, hasToken, clientId, navigate]);
  const handleBackToLogin = () => {
    localStorage.clear();
    navigate("/");
  };
  return (
    <div className="w-full lg:grid lg:grid-cols-2 min-h-screen">
      {loading && <Spin full={true} />}
      <AuthLeftSide />
      <div className="flex items-center justify-center lg:h-auto min-h-screen lg:flex-row flex-col">
        <LogoSVG className="lg:hidden fixed top-[15%] !text-webPrimary !fill-webPrimary h-28 w-full" />
        <div className="mx-auto grid w-[350px] gap-6">
          <div className="flex flex-col items-center justify-center gap-2 text-center">
            <Mail height={48} width={48} />
            <h1 className="text-3xl font-bold">Forgot Password</h1>
            <p className="text-balance text-muted-foreground">
              Enter email address to receive an email to reset your password
            </p>
          </div>
          <Formik
            initialValues={{
              email: "",
            }}
            validateOnBlur={true}
            validateOnChange={true}
            onSubmit={handleFinish}
            validationSchema={ForgotPasswordSchema}
          >
            {({
              values,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => (
              <form
                onSubmit={handleSubmit}
                className="row needs-validation"
                noValidate
              >
                <div className="grid gap-4">
                  <div className="grid gap-2">
                    <Label htmlFor="email">
                      <CustomLabelText
                        labelText="Email"
                        required={true}
                        errorField={errors?.email}
                      />
                    </Label>
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      placeholder="Enter Email"
                      required
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoFocus={true}
                      value={values.email}
                      className={
                        errors?.email &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  <Button type="submit" className="w-full">
                    Confirm
                  </Button>
                </div>
              </form>
            )}
          </Formik>
          <div className="mt-4 text-center text-sm">
            <Link to="/" className="underline" onClick={handleBackToLogin}>
              Back to Login
            </Link>
          </div>
        </div>
      </div>
      <p className="lg:hidden fixed bottom-0 p-4 text-xs flex items-start gap-1 text-justify">
        <FaviconSVG className="h-5 w-5 !text-webPrimary !fill-webPrimary" />
        <span className="flex-1">
          TrustSoft acknowledges the Traditional Custodians of country
          throughout Australia and their connections to land, sea and community.
          We pay our respect to their Elders past and present and extend that
          respect to all Aboriginal and Torres Strait Islander peoples today.
        </span>
      </p>
      <div className="fixed top-4 right-4">
        <ThemeToggle />
      </div>
    </div>
  );
};

export default ForgotPassword;
